import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import * as StyleDOM from "../../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateDocuments.jsx";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../Resume-Upload/ResumeUpload.css";
import "./Vendors.css";
import infoIcon from "../../../Assets/Images/info-icon.png";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations.js";
import Button from "../../../Common/Button/Button";
import addIcon from "../../../Assets/Images/addIcon.png";
import mailIcon from "../../../Assets/Images/mail_icon.png";
import webIcon from "../../../Assets/Images/webIcon.png";
import phoneIcon from "../../../Assets/Images/phone_icon.png";
import createClientIcon from "../../../Assets/Images/Create New Client Icon Light.svg";
import createDarkClientIcon from "../../../Assets/Images/Create New Client Icon Dark.svg";
import accountIcon from "../../../Assets/Images/accountIcon.png";
import clientsPageIcon from "../../../Assets/Images/clients-header-icon.svg";
import DynamicTextField from "../../../Common/Textfield/Textfield";
import TextInput from "../../../Common/TextInput/TextInput";
import PhoneNumberInput from "../../../Common/PhoneNumberInput/PhoneNumberInput";
import clientsPageDarkIcon from "../../../Assets/Images/clients-header-darkicon.svg";
import { DynamicContext } from "../../../Context/DynamicContext";
import { post, get, deleteRequest } from "../../../helper/Api_helper";
import jobIcon from "../../../Assets/Images/jobTypeIcon.png";
import {
  VYLABS_BASE_URL,
  GET_VENDORS_LIST,
  GET_RECRUITER_BY_ID,
  CREATE_VENDORS,
  UPDATE_VENDORS_INFO_FIELDS,
  VENDORS_TRACKING_LIST,
  VENDORS_SEARCH,
  GET_VENDOR_DETAILS_BY_ID,
  GET_CANDIDATE_BY_ID,
  RECOMMEND_JOBS,
  GET_JOB_DETAILS_BY_ID,
  UPDATE_CANDIDATE_DETAILS,
  GET_VENDOR_FILE_UPLOAD_URL,
  CREATE_VENDORS_CONTACT,
  UPDATE_VENDOR_CONTACT,
  DELETE_VENDOR_CONTACT,
  GET_CUSTOM_PORTALS,
} from "../../../helper/url_helper";
import NoDataFoundAnimation from "../../../Assets/Json/nodata-found-robot-animation.json";
import CandidateDetailsContainer from "../../../Common/Candidate-Details-Container/CandidateDetailsContainer";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar";
import SidePopup from "../../../Common/SidePopup/SidePopup";
import VendorCard from "../../../Common/Card/Vendor-Card/VendorCard";
import DynamicSkeleton from "../../../Common/Skeleton/Skeleton";
import GlobalSearchBox from "../../../Common/GlobalSearchBox/GlobalSearchBox";
import staticData from "../../../Assets/Json/StaticData.json";
import OptionsData from "../../../Assets/Json/StaticOptions.json";
import JobsCard from "../../../Common/Card/JobsCard";
import editIcon from "../../../Assets/Images/edit-track-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-red-icon.png";
import CustomTooltip from "../../../Common/Tooltip/Tooltip";
import AnimationPlayer from "../../../Common/Animation-Player/AnimationPlayer";
import sendIconDarkAnimation from "../../../Assets/Json/nodata-found-robot-animation.json";
import SelectInput from "../../../Common/Select-Input/SelectInput.js";
import NoHistoryAnimation from "../../../Assets/Json/No-History-Animation.json";
import TextArea from "../../../Common/TextArea/TextArea";
import { ConfirmationPopup } from "../../../Common/PopupStyles/PopupComponent.js";
import { applyEllipsis } from "../../../Common/Common-Function/CommonFunctions.js";
import VendorInfo from "./VendorInfo.js";
import VendorTrackingHistory from "./VendorTrackingHistory.js";
import VendorDocuments from "./VendorDocuments.js";
import VendorsCandidateList from "./VendorsCandidateList.js";
import PageSelector from "../../../Common/Page-Selector/PageSelector";
import ContactCard from "../../../Common/Contact-Card/ContactCard.js";
import AddIcon from "../../../Assets/Images/addIcon.png";
import ContentDialog from "../../../Common/Content-Dialog/ContentDialog.js";
import VendorSearchDarkIcon from "../../../Assets/Images/Vendors Search Icon Dark.svg";
import VendorSearchLightIcon from "../../../Assets/Images/Vendors Search Icon Light.svg";
import rightArrowIcon from "../../../Assets/Images/arrow-right.png";

function Vendors() {
  const { isDarkMode, isVendorIntegrationsEnabled } =
    useContext(DynamicContext);
  const navigate = useNavigate();
  const { StaticOptions = {} } = OptionsData || {};
  const { vendor_filter_options = {} } = staticData;
  const { filteroptions = [] } = vendor_filter_options || {};
  const defaultVendorFilter = filteroptions[0] || "";
  const { vendorStatus = [] } = StaticOptions;
  const { vendorPriority = [] } = StaticOptions;
  const observer = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vendorListOffset, setVendorListOffset] = useState(0);
  const [viewVendor, setViewVendor] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [activeTab, setActiveTab] = useState("Info");
  const [vendorJobsList, setVendorJobsList] = useState([]);
  const [vendorTracking, setVendorTracking] = useState([]);
  const [vendorJobsListOffset, setVendorJobsListOffset] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterKey, setFilterKey] = useState("");
  const [secondaryValue, setSecondaryValue] = useState("");
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [isEditingVendor, setIsEditingVendor] = useState(false);
  const [changedVendor, setChangedVendor] = useState([]);
  const [isFetchCompleted, setIsFetchCompleted] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [hasVendorProfiles, setHasVendorProfiles] = useState(false);
  const [recruiterNames, setRecruiterNames] = useState({});
  const [isVendorDeleteDialogOpen, setIsVendorDeleteDialogOpen] =
    useState(false);
  const [prevFilterKey, setPrevFilterKey] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [isCreatingVendor, setIsCreatingVendor] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showPersonal, setShowPersonal] = useState(false);
  const [locationDetails, setLocationDetails] = useState(false);
  const [fileUploads, setFileUploads] = useState(false);
  const [selectedCandidateForModal, setSelectedCandidateForModal] =
    useState(null);
  const [isCandidateModalOpen, setIsCandidateModalOpen] = useState(false);
  const [candidateActiveTab, setCandidateActiveTab] = useState(0);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [candidateEmailError, setCandidateEmailError] = useState("");
  const [candidateEmailTouched, setCandidateEmailTouched] = useState(false);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [editAchFile, setEditAchFile] = useState(null);
  const [editVoidChequeFile, setEditVoidChequeFile] = useState(null);
  const [editAuditDocument, setEditAuditDocument] = useState(null);
  const [showVendorContactPopup, setShowVendorContactPopup] = useState(false);
  const [showEditContactPopup, setShowEditContactPopup] = useState(false);
  const [showDeleteContactPopup, setShowDeleteContactPopup] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const achFileRef = useRef(null);
  const voidChequeRef = useRef(null);
  const auditDocRef = useRef(null);
  const [enabledPortalKeys, setEnabledPortalKeys] = useState(new Set());

  const cepheaVendorIds = [
    "e1245788277a47f285ac0374ce5fad34", // Monster Portal Search (USA)
    "335e835f724947ee9eea9f2b6fea6504", // Monster Portal Search
    "9a1d629dab1a46a7b4381db90451b543", // Dice Portal Search
  ];
  const isCepheaVendor = (vendorId) => {
    return cepheaVendorIds.includes(vendorId);
  };
  const formik = useFormik({
    initialValues: {
      email: "",
      nameOfVendor: "",
      companyType: "",
      contactPerson: "",
      contactPersonName: "",
      contactDesignation: "",
      federalTax: "",
      bankName: "",
      accountName: "",
      accountNumber: "",
      routingNumber: "",
      natureOfAccount: "",
      farcaCode: "",
      exemptPayeeCode: "",
      achFile: null,
      voidChequeFile: null,
      documentType: null,
      mobile: "",
      secondaryMobile: "",
      country: "",
      state: "",
      city: "",
      address: "",
      // address2: "",
      vendorStatus: "",
      vendorPriority: "",
      zipCode: "",
      remarks: "",
    },

    validationSchema: Yup.object({
      nameOfVendor: Yup.string().trim().required("Vendor Name is required"),
      email: Yup.string()
        .email("Invalid email")
        .trim()
        .required("Email is required"),
      mobile: Yup.string()
        .trim()
        .required("Mobile is required")
        .matches(/^(\+)?[0-9\s\-\\(\\)]+$/, "Invalid phone number"),
      contactPersonName: Yup.string()
        .trim()
        .required("Contact Person Name is required"),
      address: Yup.string().trim(),
      city: Yup.string().trim(),
      state: Yup.string().trim(),
      zipCode: Yup.string()
        .trim()
        .matches(/^[0-9]*$/, "Only digits are allowed for Zipcode."),
      federalTax: Yup.string().trim(),
      bankName: Yup.string().trim(),
      accountName: Yup.string().trim(),
      accountNumber: Yup.string().trim(),
      routingNumber: Yup.string().trim(),
      natureOfAccount: Yup.string().trim(),
      farcaCode: Yup.string().trim(),
      exemptPayeeCode: Yup.string().trim(),
      vendorStatus: Yup.string().required("Status is required"),
      vendorPriority: Yup.string().required("Priority is required"),
    }),
  });
  const contactFormik = useFormik({
    initialValues: {
      contactName: "",
      contactEmail: "",
      contactPhoneNumber: "",
      contactDesignation: "",
    },
    validationSchema: Yup.object({
      contactName: Yup.string()
        .trim()
        .required("Contact Person Name is required")
        .min(2, "Contact Person Name must be at least 2 characters"),
      contactEmail: Yup.string()
        .email("Invalid email address")
        .trim()
        .required("Email is required"),
      contactPhoneNumber: Yup.string()
        .trim()
        .required("Phone number is required")
        .matches(/^(\+)?[0-9\s\-\(\)]+$/, "Invalid phone number"),
      contactDesignation: Yup.string()
        .trim()
        .required("Designation is required"),
    }),
    onSubmit: (values) => {
      if (isEditingContact) {
        handleUpdateVendorContactDetails(values);
      } else {
        handleCreateVendorContactDetails(values);
      }
    },
  });
  const handleOpenAddContactPopup = () => {
    setIsEditingContact(false);
    setSelectedContact(null);
    contactFormik.resetForm();
    setShowVendorContactPopup(true);
  };

  const handleOpenEditContactPopup = (contact) => {
    setIsEditingContact(true);
    setSelectedContact(contact);
    contactFormik.setValues({
      contactName: contact.name || "",
      contactEmail: contact.email || "",
      contactPhoneNumber: contact.phone || "",
      contactDesignation: contact.designation || "",
    });
    setShowEditContactPopup(true);
  };
  const handleOpenDeleteContactPopup = (contact) => {
    setSelectedContact(contact);
    setShowDeleteContactPopup(true);
  };

  const handleCloseContactPopup = () => {
    setShowVendorContactPopup(false);
    setShowEditContactPopup(false);
    contactFormik.resetForm();
    setSelectedContact(null);
    setIsEditingContact(false);
  };

  const handleCreateVendorContactDetails = async (values) => {
    try {
      const errors = await contactFormik.validateForm();
      if (Object.keys(errors).length > 0) {
        contactFormik.setTouched({
          contactName: true,
          contactEmail: true,
          contactPhoneNumber: true,
          contactDesignation: true,
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      await post(VYLABS_BASE_URL, CREATE_VENDORS_CONTACT, {
        email: values.contactEmail.trim(),
        id: selectedVendor?.id,
        name: values.contactName.trim(),
        phone: values.contactPhoneNumber.startsWith("+")
          ? values.contactPhoneNumber
          : `+${values.contactPhoneNumber}`,
        designation: values.contactDesignation.trim(),
      });
      Toast("success", "Contact added successfully");
      handleCloseContactPopup();
      if (selectedVendor?.id) {
        await fetchVendorDetails();
      }
    } catch (error) {
      console.error("Create Vendor Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to add contact. Please try again.",
      );
    }
  };

  const handleUpdateVendorContactDetails = async (values) => {
    try {
      const errors = await contactFormik.validateForm();
      if (Object.keys(errors).length > 0) {
        contactFormik.setTouched({
          contactName: true,
          contactEmail: true,
          contactPhoneNumber: true,
          contactDesignation: true,
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      await post(VYLABS_BASE_URL, UPDATE_VENDOR_CONTACT, {
        id: selectedContact?.id,
        email: values.contactEmail.trim(),
        name: values.contactName.trim(),
        phone: values.contactPhoneNumber.startsWith("+")
          ? values.contactPhoneNumber
          : `+${values.contactPhoneNumber}`,
        designation: values.contactDesignation.trim(),
      });
      Toast("success", "Contact updated successfully");
      handleCloseContactPopup();
      if (selectedVendor?.id) {
        await fetchVendorDetails();
      }
    } catch (error) {
      console.error("Update Vendor Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to update contact. Please try again.",
      );
    }
  };

  const handleDeleteVendorContactDetails = async () => {
    if (!selectedContact?.id) {
      Toast("error", "No contact selected for deletion");
      return;
    }

    try {
      await deleteRequest(VYLABS_BASE_URL, DELETE_VENDOR_CONTACT, {
        id: selectedContact.id,
      });
      Toast("success", "Contact deleted successfully");
      setShowDeleteContactPopup(false);
      setSelectedContact(null);

      if (selectedVendor?.id) {
        await fetchVendorDetails();
      }
    } catch (error) {
      console.error("Delete Vendor Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to delete contact. Please try again.",
      );
    }
  };

  useEffect(() => {
    if (selectedVendor) {
      const initialValues = {
        email: selectedVendor?.email || "",
        nameOfVendor: selectedVendor?.name || "",
        contactPersonName: selectedVendor?.contact_person || "",
        contactDesignation: selectedVendor?.contact_designation || "",
        mobile: selectedVendor?.phone || "",
        country: selectedVendor?.country || "",
        state: selectedVendor?.state || "",
        city: selectedVendor?.city || "",
        address: selectedVendor?.address || "",
        // address2: selectedVendor?.address_2 || "",
        zipCode: selectedVendor?.zip_code || "",
        remarks: selectedVendor?.remarks || "",
        vendorStatus: selectedVendor?.status || "",
        vendorPriority: selectedVendor?.priority || "",
        federalTax: selectedVendor?.federal_tax || "",
        bankName: selectedVendor?.bank_name || "",
        accountName: selectedVendor?.account_name || "",
        accountNumber: selectedVendor?.account_number || "",
        routingNumber: selectedVendor?.routing_number || "",
        natureOfAccount: selectedVendor?.account_nature || "",
        farcaCode: selectedVendor?.farca_reporting_code || "",
        exemptPayeeCode: selectedVendor?.exempt_payee_code || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
    }
  }, [selectedVendor]);

  useEffect(() => {
    if (activeTab === "Info") {
      setShowLoader(true);
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 700);
      return () => clearTimeout(timer);
    }
  }, [activeTab]);

  const fetchAllVendorsList = async (customOffset = vendorListOffset) => {
    try {
      if (customOffset === 0) {
        setIsInitialLoading(true);
      } else {
        setIsLoadingMore(true);
      }

      const response = await post(VYLABS_BASE_URL, GET_VENDORS_LIST, {
        offset: customOffset,
        limit: 30,
      });
      const { vendors = [] } = response;
      const fetchedVendors = Array.isArray(vendors)
        ? vendors.filter((v) => v?.id)
        : [];

      if (fetchedVendors.length > 0) {
        setHasVendorProfiles(true);
      } else if (customOffset === 0) {
        setHasVendorProfiles(false);
      }

      setVendorList((prev) => {
        if (customOffset === 0) {
          return fetchedVendors;
        } else {
          const existingVendors = new Map();
          (prev || []).forEach((vendor) => {
            if (vendor?.id) existingVendors.set(vendor.id, vendor);
          });
          fetchedVendors.forEach((vendor) => {
            if (vendor?.id) existingVendors.set(vendor.id, vendor);
          });
          return Array.from(existingVendors.values());
        }
      });

      setHasMore(vendors.length === 30);
    } catch (err) {
      console.error("fetchAllVendorsList error", err);
      setVendorList((prev) => prev || []);
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
      setIsFetchCompleted(true);
    }
  };

  const getVendorsDetails = async (vendorId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_VENDOR_DETAILS_BY_ID}?id=${vendorId}`,
      );
      setSelectedVendor(response);
      setChangedVendor(response);
      setViewVendor(true);
      setShowPersonal(true);
      setLocationDetails(false);
      setFileUploads(false);
    } catch (err) {
      console.error("Vendor Details error", err);
    }
  };

  useEffect(() => {
    fetchAllVendorsList();
  }, [vendorListOffset]);

  const uploadFileToS3 = async (file, fileType) => {
    if (!file) return null;

    try {
      const response = await post(VYLABS_BASE_URL, GET_VENDOR_FILE_UPLOAD_URL, {
        file_name: file.name,
      });
      const { url, object_key } = response;

      if (!url || !object_key) {
        throw new Error("Invalid response from get-upload-url API");
      }
      const uploadResponse = await fetch(url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      if (!uploadResponse.ok) {
        throw new Error(
          `Failed to upload ${fileType} to S3: ${uploadResponse.status}`,
        );
      }

      return {
        file_name: file.name,
        object_key: object_key,
      };
    } catch (error) {
      console.error(`Error uploading ${fileType} to S3:`, error);
      throw error;
    }
  };
  const handleCreateVendor = async () => {
    try {
      const errors = await formik.validateForm();
      if (Object.keys(errors).length > 0) {
        Object.keys(errors).forEach((key) => {
          formik.setFieldTouched(key, true, false);
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }
      const achData = formik.values.achFile
        ? await uploadFileToS3(formik.values.achFile, "ACH file")
        : null;
      const voidChequeData = formik.values.voidChequeFile
        ? await uploadFileToS3(formik.values.voidChequeFile, "Void Cheque file")
        : null;
      const auditData = formik.values.documentType
        ? await uploadFileToS3(formik.values.documentType, "Audit Document")
        : null;
      setIsCreatingVendor(true);
      const payload = {
        name: formik.values.nameOfVendor.trim(),
        email: formik.values.email.trim(),
        phone: formik.values.mobile.startsWith("+")
          ? formik.values.mobile
          : `+${formik.values.mobile}`,
        address: formik.values.address.trim(),
        city: formik.values.city.trim(),
        country: formik.values.country.trim(),
        state: formik.values.state.trim(),
        zip_code: formik.values.zipCode.trim(),
        contact_person: formik.values.contactPersonName.trim(),
        contact_designation: formik.values.contactDesignation.trim(),
        federal_tax: formik.values.federalTax.trim(),
        bank_name: formik.values.bankName.trim(),
        account_name: formik.values.accountName.trim(),
        account_number: formik.values.accountNumber.trim(),
        routing_number: formik.values.routingNumber.trim(),
        account_nature: formik.values.natureOfAccount.trim(),
        farca_reporting_code: formik.values.farcaCode.trim(),
        exempt_payee_code: formik.values.exemptPayeeCode.trim(),
        status: formik.values.vendorStatus,
        priority: formik.values.vendorPriority,
        ach_file_upload: achData,
        void_cheque_file_upload: voidChequeData,
        audit_document_file_upload: auditData,
        remarks: formik.values.remarks,
      };
      await post(VYLABS_BASE_URL, CREATE_VENDORS, payload);
      Toast("success", "Vendor Created Successfully");
      setIsModalOpen(false);
      resetFileInputs();
      formik.resetForm();
      setVendorList([]);
      setVendorListOffset(0);
      await fetchAllVendorsList(0);
    } catch (error) {
      console.error("Create Vendor response error:", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Vendor creation failed. Please try again.",
      );
    } finally {
      setIsCreatingVendor(false);
    }
  };

  const lastElement = useCallback(
    (node) => {
      if (!hasMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            setIsLoadingMore(true);
            setVendorListOffset((prev) => prev + 30);
          }
        },
        {
          root: null,
          rootMargin: "20px",
          threshold: 0.1,
        },
      );

      if (node) observer.current.observe(node);
    },
    [hasMore],
  );
  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);
  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      const normalizedPhone = phone?.startsWith("+") ? phone : `+${phone}`;
      formik.setFieldValue("mobile", normalizedPhone);
      formik.setFieldTouched("mobile", true, false);
      formik.validateField("mobile");
    },
    [formik],
  );
  const handleContactPhoneInputChange = React.useCallback(
    (phone) => {
      const normalizedPhone = phone?.startsWith("+") ? phone : `+${phone}`;
      contactFormik.setFieldValue("contactPhoneNumber", normalizedPhone);
      contactFormik.setFieldTouched("contactPhoneNumber", true, false);
      contactFormik.validateField("contactPhoneNumber");
    },
    [contactFormik],
  );
  const handleOpenInviteModal = () => {
    setIsModalOpen(true);
    setSelectedVendor(null);
    setIsEditingVendor(false);
    formik.resetForm();
    resetFileInputs();
  };
  const handleCloseInviteModal = () => {
    setIsModalOpen(false);
    formik.resetForm();
    resetFileInputs();
    setSelectedVendor(null);
    setIsEditingVendor(false);
  };
  const handleCloseClientDetails = () => {
    setViewVendor(false);
    setSelectedVendor(null);
    setActiveTab("Info");
    setIsEditingVendor(false);
    formik.resetForm();
    setShowPersonal(true);
    setLocationDetails(false);
    setFileUploads(false);
  };

  const handleBackToVendorsList = async () => {
    setSearchQuery("");
    setFilterKey(defaultVendorFilter);
    setPrevFilterKey(defaultVendorFilter);
    setSecondaryValue("");
    setHasSearched(false);
    setVendorListOffset(0);
    setVendorList([]);
    setSearchResetKey((prev) => prev + 1);
    handleCloseClientDetails();
    await fetchAllVendorsList(0);
  };

  const handleOpenClientDeleteDialog = () => {
    setIsVendorDeleteDialogOpen(true);
  };

  const handleDeleteVendors = async () => {
    if (!selectedVendor?.id) {
      Toast("error", "No vendor selected for deletion");
      return;
    }
    try {
      await deleteRequest(VYLABS_BASE_URL, `vendors?id=${selectedVendor.id}`, {
        id: selectedVendor.id,
      });
      Toast("success", "Vendor deleted successfully");
      setIsVendorDeleteDialogOpen(false);
      setViewVendor(false);
      setSelectedVendor(null);
      setIsEditingVendor(false);
      setVendorList([]);
      setVendorListOffset(0);
      await fetchAllVendorsList(0);
    } catch (error) {
      console.error("Error deleting vendor:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to delete vendor. Please try again.";
      Toast("error", errorMessage);
    }
  };

  const resetFileInputs = () => {
    if (achFileRef.current) achFileRef.current.value = "";
    if (voidChequeRef.current) voidChequeRef.current.value = "";
    if (auditDocRef.current) auditDocRef.current.value = "";
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    if (e.target.value.length === 0) {
      fetchAllVendorsList();
      setHasSearched(false);
    }
  };

  const onFilterClick = (option) => {
    if (!prevFilterKey || prevFilterKey.id !== option.id) {
      if (option.id !== "vendorPriority" && option.id !== "vendorStatus") {
        setSecondaryValue("");
      }
    }
    setFilterKey(option);
    setPrevFilterKey(option);
    if (option.secondaryValue) {
      setSecondaryValue(option.secondaryValue);
    }
  };

  const handleVendorSearch = async () => {
    const isSearchEmpty = !searchQuery?.trim();
    const isSecondaryEmpty = !secondaryValue?.trim();
    const activeFilterKey = filterKey?.id ? filterKey : defaultVendorFilter;
    if (isSearchEmpty && isSecondaryEmpty) {
      Toast("error", "Please enter a search query.");
      return;
    }
    if (!activeFilterKey || !activeFilterKey.id) {
      Toast("error", "Please select a search filter.");
      return;
    }
    try {
      setIsInitialLoading(true);
      setVendorListOffset(0);
      setVendorList([]);
      setHasSearched(true);

      let searchUrl = `${VENDORS_SEARCH}?`;

      if (searchQuery?.trim()) {
        searchUrl += `${activeFilterKey.id}=${searchQuery}`;
      }

      if (secondaryValue) {
        if (searchQuery?.trim()) {
          searchUrl += "&";
        }
        if (activeFilterKey.name === "Vendor Status") {
          searchUrl += `status=${secondaryValue}`;
        } else {
          searchUrl += `${activeFilterKey.name.toLowerCase()}=${secondaryValue}`;
        }
      }
      const response = await get(VYLABS_BASE_URL, searchUrl);
      const { vendors = [] } = response;
      let searchResults = Array.isArray(vendors)
        ? vendors.filter((vendor) => vendor?.name)
        : [];
      const isPriorityFilter = activeFilterKey.id === "vendorPriority";
      const isStatusFilter = activeFilterKey.id === "vendorStatus";
      const hasSearchInput = searchQuery?.trim().length > 0;
      if (
        (isPriorityFilter || isStatusFilter) &&
        hasSearchInput &&
        secondaryValue
      ) {
        const inputLower = searchQuery.trim().toLowerCase();
        const matchesInput = (vendor) => {
          return (
            (vendor.name && vendor.name.toLowerCase().includes(inputLower)) ||
            (vendor.email && vendor.email.toLowerCase().includes(inputLower)) ||
            (vendor.contact_person &&
              vendor.contact_person.toLowerCase().includes(inputLower))
          );
        };
        if (isPriorityFilter) {
          searchResults = searchResults.filter(
            (vendor) =>
              vendor.priority.toLowerCase() === secondaryValue.toLowerCase() &&
              matchesInput(vendor),
          );
        } else if (isStatusFilter) {
          searchResults = searchResults.filter(
            (vendor) =>
              vendor.status &&
              vendor.status.toLowerCase() === secondaryValue.toLowerCase() &&
              matchesInput(vendor),
          );
        }
      }

      setVendorList(searchResults);
      setHasMore(searchResults.length === 30);
    } catch (error) {
      console.error("Search failed with error:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response,
        status: error.response?.status,
      });
      setVendorList([]);
    } finally {
      setIsInitialLoading(false);
    }
  };

  const handleEditClient = async () => {
    setIsEditingVendor(true);
    setActiveTab("Info");
    setShowPersonal(true);
    setLocationDetails(false);
  };
  const handleCancelEditClient = () => {
    setIsEditingVendor(false);
    resetEditFileStates();
    if (selectedVendor) {
      const initialValues = {
        email: selectedVendor?.email || "",
        nameOfVendor: selectedVendor?.name || "",
        contactPersonName: selectedVendor?.contact_person || "",
        contactDesignation: selectedVendor?.contact_designation || "",
        mobile: selectedVendor?.phone || "",
        country: selectedVendor?.country || "",
        state: selectedVendor?.state || "",
        city: selectedVendor?.city || "",
        address: selectedVendor?.address || "",
        // address2: selectedVendor?.address2 || "",
        zipCode: selectedVendor?.zip_code || "",
        remarks: selectedVendor?.remarks || "",
        vendorStatus: selectedVendor?.status || "",
        vendorPriority: selectedVendor?.priority || "",
        federalTax: selectedVendor?.federal_tax || "",
        bankName: selectedVendor?.bank_name || "",
        accountName: selectedVendor?.account_name || "",
        accountNumber: selectedVendor?.account_number || "",
        routingNumber: selectedVendor?.routing_number || "",
        natureOfAccount: selectedVendor?.account_nature || "",
        farcaCode: selectedVendor?.farca_reporting_code || "",
        exemptPayeeCode: selectedVendor?.exempt_payee_code || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
      formik.setErrors({});
    }
  };

  const resetEditFileStates = () => {
    setEditAchFile(null);
    setEditVoidChequeFile(null);
    setEditAuditDocument(null);
  };

  const handleEditAchFileChange = (event) => {
    const file = event.target.files[0];
    setEditAchFile(file);
  };

  const handleEditVoidChequeFileChange = (event) => {
    const file = event.target.files[0];
    setEditVoidChequeFile(file);
  };

  const handleEditAuditDocumentChange = (event) => {
    const file = event.target.files[0];
    setEditAuditDocument(file);
  };

  const saveVendorChanges = async () => {
    if (!selectedVendor) {
      Toast("error", "No vendor selected");
      return;
    }
    try {
      let achUploadData = null;
      let voidChequeUploadData = null;
      let auditDocumentUploadData = null;

      const payloadValues = {
        name: formik.values.nameOfVendor.trim(),
        email: formik.values.email.trim(),
        phone: formik.values.mobile
          ? formik.values.mobile.startsWith("+")
            ? formik.values.mobile
            : `+${formik.values.mobile}`
          : "",
        contact_person: formik.values.contactPersonName.trim(),
        contact_designation: formik.values.contactDesignation.trim(),
        address: formik.values.address.trim(),
        city: formik.values.city.trim(),
        country: formik.values.country.trim(),
        state: formik.values.state.trim(),
        zip_code: formik.values.zipCode.trim(),
        federal_tax: formik.values.federalTax.trim(),
        bank_name: formik.values.bankName.trim(),
        account_name: formik.values.accountName.trim(),
        account_number: formik.values.accountNumber.trim(),
        routing_number: formik.values.routingNumber.trim(),
        account_nature: formik.values.natureOfAccount.trim(),
        farca_reporting_code: formik.values.farcaCode.trim(),
        exempt_payee_code: formik.values.exemptPayeeCode.trim(),
      };
      const changes = {};
      for (const key in payloadValues) {
        const currentValue = payloadValues[key];
        const originalValue = selectedVendor[key];
        const normalizedCurrentValue =
          currentValue === null || currentValue === undefined
            ? ""
            : String(currentValue).trim();
        const normalizedOriginalValue =
          originalValue === null || originalValue === undefined
            ? ""
            : String(originalValue).trim();
        if (normalizedCurrentValue !== normalizedOriginalValue) {
          changes[key] = currentValue;
        }
      }
      if (achUploadData) {
        changes.coi_upload_url = achUploadData.url;
      }
      if (voidChequeUploadData) {
        changes.w9_upload_url = voidChequeUploadData.url;
      }
      if (auditDocumentUploadData) {
        changes.msa_upload_url = auditDocumentUploadData.url;
      }

      if (Object.keys(changes).length === 0) {
        Toast("info", "No changes detected");
        setIsEditingVendor(false);
        return;
      }
      const payload = {
        id: selectedVendor.id,
        ...changes,
      };
      await post(VYLABS_BASE_URL, UPDATE_VENDORS_INFO_FIELDS, payload);
      Toast("success", "Vendor updated successfully");
      const updatedVendorState = { ...selectedVendor };
      for (const key in changes) {
        updatedVendorState[key] = changes[key];
      }
      setSelectedVendor(updatedVendorState);
      setChangedVendor(updatedVendorState);
      setIsEditingVendor(false);
      resetEditFileStates();
      await fetchAllVendorsList(0);
    } catch (error) {
      console.error("Error updating vendor:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update vendor. Please try again.";
      Toast("error", errorMessage);
    }
  };
  const fetchVendorDetails = useCallback(async () => {
    if (selectedVendor?.id) {
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_VENDOR_DETAILS_BY_ID}?id=${selectedVendor.id}`,
        );
        setSelectedVendor(response);
        setChangedVendor(response);
      } catch (err) {
        console.error("Error refreshing vendor details:", err);
      }
    }
  }, [selectedVendor?.id]);

  const renderContent = () => {
    switch (activeTab) {
      case "Jobs": {
        if (showLoader) {
          return <VybogTALLoaderAnimation />;
        }
        return (
          <div className="jobs-tab-container">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0,
                gap: "48px",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  height: "26px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "20px",
                  lineHeight: "26px",
                  letterSpacing: "-0.01em",
                  color: "--header__color",
                }}
              >
                {vendorJobsList.length > 0 && <>Vendor Jobs</>}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {isInitialLoading || isCreatingVendor ? (
                <VybogTALLoaderAnimation />
              ) : vendorJobsList && vendorJobsList.length > 0 ? (
                vendorJobsList.map((job, index) => {
                  const jobIcon = webIcon;
                  return (
                    <JobsCard
                      key={index}
                      title={job.title}
                      subTitle={job.subTitle}
                      icon={jobIcon}
                      tags={job.tags}
                      location={job.location}
                      experience={job.years_experience}
                      jobtype={job.job_type}
                      minSalary={job.salary_max}
                      maxSalary={job.salary_min}
                      client={job?.client?.name}
                      client_contact_person={
                        job?.client_contact
                          ? job?.client_contact?.name
                          : job?.client?.contact_person
                      }
                      jobRole={job?.job_role}
                      actionText={job.actionText}
                      isActive={job.active}
                      viewJob={job.viewJob}
                      jobId={index}
                    />
                  );
                })
              ) : (
                <>
                  <StyleDOM.HistoryInfoText className="history-info">
                    <img
                      src={infoIcon}
                      alt="infoIcon"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <StyleDOM.HistoryInfoText className="history-info-text">
                      No jobs have been created for this vendor yet. Create a
                      new job to start recruiting candidates for this vendor
                    </StyleDOM.HistoryInfoText>
                  </StyleDOM.HistoryInfoText>
                  <StyleDOM.NoTrackingHistory className="no-tracking-history">
                    <AnimationPlayer
                      animationSrc={NoHistoryAnimation}
                      playerHeight="200px"
                      playerWidth="300px"
                    />
                  </StyleDOM.NoTrackingHistory>
                </>
              )}
            </div>
          </div>
        );
      }
      case "Info": {
        return (
          <VendorInfo
            selectedVendor={selectedVendor}
            setSelectedVendor={setSelectedVendor}
            setChangedVendor={setChangedVendor}
            isEditingVendor={isEditingVendor}
            setIsEditingVendor={setIsEditingVendor}
            fetchAllVendorsList={fetchAllVendorsList}
            formik={formik}
            handlePhoneInputChange={handlePhoneInputChange}
          />
        );
      }
      case "Documents": {
        return (
          <VendorDocuments
            selectedVendor={selectedVendor}
            isEditingVendor={isEditingVendor}
            editAchFile={editAchFile}
            editVoidChequeFile={editVoidChequeFile}
            editAuditDocument={editAuditDocument}
            handleEditAchFileChange={handleEditAchFileChange}
            handleEditVoidChequeFileChange={handleEditVoidChequeFileChange}
            handleEditAuditDocumentChange={handleEditAuditDocumentChange}
            onVendorUpdate={fetchVendorDetails}
          />
        );
      }
      case "History": {
        return (
          <VendorTrackingHistory
            selectedVendor={selectedVendor}
            getVendorID={selectedVendor?.id}
          />
        );
      }
      case "Vendor's Candidate": {
        return (
          <VendorsCandidateList
            selectedVendor={selectedVendor}
            getVendorID={selectedVendor?.id}
            onCandidateCardView={handleCandidateCardView}
          />
        );
      }
      case "Additional Contacts": {
        const contacts = selectedVendor?.contacts || [];
        const hasContacts = contacts.length > 0;
        return (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: "-15px",
              }}
            >
              <Button
                label="Add Contact"
                event={handleOpenAddContactPopup}
                iconSrc={AddIcon}
                iconWidth="15px"
                style={{ padding: "8px 15px" }}
                backgroundColor="#6860EE"
                color="#FFFFFF"
                border="none"
              />
            </div>

            {hasContacts ? (
              <ContactCard
                contacts={selectedVendor?.contacts || []}
                onEditContact={handleOpenEditContactPopup}
                onDeleteContact={handleOpenDeleteContactPopup}
                title="Additional Contacts"
              />
            ) : (
              <div
                className="no-contacts-container"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "40px 20px",
                  textAlign: "center",
                }}
              >
                <StyleDOM.HistoryInfoText className="history-info-text">
                  No additional contacts have been added for this vendor yet.
                  Click the "Add Contact" button to add alternative contact
                  persons.
                </StyleDOM.HistoryInfoText>
                <AnimationPlayer
                  animationSrc={NoDataFoundAnimation}
                  playerHeight="250px"
                  playerWidth="300px"
                />
              </div>
            )}
          </>
        );
      }
      default:
        return;
    }
  };

  const fetchVendors = async (inputValue = "") => {
    try {
      setVendorOptionLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(inputValue)}`,
      );
      const { vendors = [] } = response;
      const fetchedVendors = Array.isArray(vendors)
        ? vendors
            .filter((v) => v?.id && v?.name)
            .map((v) => ({
              label: v.contact_person
                ? `${v.name} - ${v.contact_person}`
                : v.name,
              value: v.id,
            }))
        : [];
      setVendorList(fetchedVendors);
    } catch (err) {
      console.error("fetchVendors error", err);
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };
  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) {
      fetchVendors(value);
    } else {
      setVendorList([]);
    }
  };

  const fetchCandidateByIdForModal = useCallback(async (id) => {
    try {
      const res = await get(VYLABS_BASE_URL, `${GET_CANDIDATE_BY_ID}?id=${id}`);
      const candidate = res?.candidate;
      const candidatefiles = res?.files;
      const parsedResumeData = candidate?.parsed_resume
        ? JSON.parse(candidate.parsed_resume)
        : null;
      const presignedUrl =
        candidatefiles && candidatefiles.length > 0
          ? candidatefiles[0].presigned_url
          : null;

      const updatedCandidate = {
        ...candidate,
        secondaryEmail: candidate.secondary_email,
        secondaryPhone: candidate.secondary_phone,
        vendorID: candidate.vendor_id,
        lineAddress1: candidate.line_address_1,
        lineAddress2: candidate.line_address_2,
        preferredSalary: candidate.preferred_salary,
        zipCode: candidate.zip_code,
        parsedResumeData,
        files: candidatefiles || null,
        presignedUrl,
        isFileBased: false,
        avatar: res?.profile_img_url,
      };
      if (updatedCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendorID}`,
          );
          setAssignedVendor(vendorResponse);
          updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          updatedCandidate.vendorDetails = null;
          setAssignedVendor(null);
        }
      } else {
        updatedCandidate.vendorDetails = null;
        setAssignedVendor(null);
      }

      setSelectedCandidateForModal(updatedCandidate);
      setIsCandidateModalOpen(true);
      return updatedCandidate;
    } catch (error) {
      console.error("Error fetching candidate:", error);
      Toast(
        "error",
        error.response.data || "Failed to fetch candidate details",
      );
      throw error;
    }
  }, []);

  const fetchRecommendedJobs = useCallback(async (candidateId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${RECOMMEND_JOBS}?candidate_id=${candidateId}`,
      );
      return response || [];
    } catch (error) {
      console.error("Error fetching recommended jobs:", error);
      return [];
    }
  }, []);

  const fetchJobDetailsById = useCallback(async (jobId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      return response?.job || null;
    } catch (error) {
      console.error("Error fetching job details for ID", jobId, ":", error);
      return null;
    }
  }, []);

  const handleCandidateCardView = useCallback(
    async (candidate) => {
      try {
        let candidateDetails;
        if (candidate.id) {
          candidateDetails = await fetchCandidateByIdForModal(candidate.id);
        } else {
          candidateDetails = candidate;
        }
        if (!candidateDetails) {
          console.error("Failed to fetch candidate details");
          Toast("error", "Failed to fetch candidate details");
          return;
        }
        const response = await fetchRecommendedJobs(candidateDetails.id);
        const jobIds = response || [];
        const jobDetailPromises = jobIds.map((job) =>
          fetchJobDetailsById(job.id || job.job_id),
        );
        const recommendedJobs = (await Promise.all(jobDetailPromises)).filter(
          Boolean,
        );
        setSelectedCandidateForModal({
          ...candidateDetails,
          recommendedJobs,
        });
        setIsCandidateModalOpen(true);
      } catch (error) {
        console.error("Error in handleCandidateCardView:", error);
        Toast("error", "Error opening candidate details");
      }
    },
    [fetchCandidateByIdForModal, fetchRecommendedJobs, fetchJobDetailsById],
  );

  const closeCandidateModal = () => {
    setIsCandidateModalOpen(false);
    setSelectedCandidateForModal(null);
    setCandidateActiveTab(0);
    resetCandidateEdit();
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setSelectedCandidateForModal(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setCandidateEmailError("");
    setCandidateEmailTouched(false);
  };

  const handleCandidateTabChange = (index) => {
    setCandidateActiveTab(index);
  };

  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidateForModal?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidateForModal?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }
    const candidateWithFormattedSkills = {
      ...selectedCandidateForModal,
      name:
        selectedCandidateForModal.name ||
        selectedCandidateForModal.BasicInfo?.Name ||
        "",
      email:
        selectedCandidateForModal.email ||
        selectedCandidateForModal.BasicInfo?.Email ||
        "",
      secondaryEmail:
        selectedCandidateForModal.secondaryEmail ||
        selectedCandidateForModal.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidateForModal.phone ||
        selectedCandidateForModal.BasicInfo?.PhoneNumber ||
        "",
      secondaryPhone:
        selectedCandidateForModal.secondaryPhone ||
        selectedCandidateForModal.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidateForModal.city ||
        selectedCandidateForModal.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidateForModal.state ||
        selectedCandidateForModal.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidateForModal.country ||
        selectedCandidateForModal.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidateForModal.skills)
        ? selectedCandidateForModal.skills
        : selectedCandidateForModal.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidateForModal.vendorID ||
        selectedCandidateForModal.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidateForModal.designation?.trim() ||
        selectedCandidateForModal.parsedResumeData?.CareerHistory
          ?.JobDetails?.[0]?.JobTitle ||
        "",
      experience: experienceValue,
      lineAddress1:
        selectedCandidateForModal.lineAddress1 ||
        selectedCandidateForModal.BasicInfo?.LineAddress1 ||
        "",
      lineAddress2:
        selectedCandidateForModal.lineAddress2 ||
        selectedCandidateForModal.BasicInfo?.LineAddress2 ||
        "",
      zipCode:
        selectedCandidateForModal.zipCode ||
        selectedCandidateForModal.BasicInfo?.ZipCode ||
        "",
      preferredSalary:
        selectedCandidateForModal.preferredSalary ||
        selectedCandidateForModal.BasicInfo?.PreferredSalary ||
        "",
    };
    setOriginalCandidateData({ ...selectedCandidateForModal });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setCandidateEmailError("");
    setCandidateEmailTouched(false);
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      Toast("error", "No changes to save");
      return;
    }
    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidateForModal.email || "";
    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    setEmailError("");
    setEmailTouched(false);
    try {
      const candidateData = { id: selectedCandidateForModal.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidateForModal[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          newValue !== ""
        ) {
          candidateData[key] = newValue;
        }
      });

      if (Object.keys(candidateData).length === 1) {
        Toast("error", "No changes to save");
        return;
      }

      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );
      if (response) {
        const updatedCandidate = {
          ...selectedCandidateForModal,
          ...candidateData,
        };

        if (
          candidateData.vendorID !== undefined &&
          candidateData.vendorID !== selectedCandidateForModal.vendorID
        ) {
          if (candidateData.vendorID) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidateData.vendorID}`,
              );
              updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
              setAssignedVendor(vendorResponse);
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
              setAssignedVendor(null);
            }
          } else {
            updatedCandidate.vendorDetails = null;
            setAssignedVendor(null);
          }
        }
        setSelectedCandidateForModal(updatedCandidate);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => {
      const updated = { ...prev, ...data };
      return updated;
    });
  };
  const handleMonsterUsaSearchNavigation = () => {
    navigate("/monster-search-usa");
  };

  const handleIrmtSearchNavigation = () => {
    navigate("/irmt-search");
  };

  const handleDiceSearchNavigation = async () => {
    navigate("/dice-search");
  };

  const handleTabClick = (tabName) => {
    if (isEditingVendor && tabName !== "Info") {
      Toast(
        "warning",
        "Please save or cancel your changes before switching tabs",
      );
      return;
    }
    setActiveTab(tabName);
    if (tabName === "Info") {
      setShowPersonal(true);
      setLocationDetails(false);
    }
  };
  const VENDOR_PORTAL_KEY_MAP = {
    "Dice Search": "dice",
    "Monster Search ( IND )": "foundit",
    "Monster Search ( USA )": "monsterus",
    "IRMT Search": "irmt",
  };

  const fetchConnectedPortals = async () => {
    try {
      const response = await get(VYLABS_BASE_URL, GET_CUSTOM_PORTALS);
      const enabledKeys = new Set(
        (response || [])
          .filter((portalEntry) => portalEntry?.enabled)
          .map((portalEntry) => portalEntry?.portal?.toLowerCase()),
      );
      setEnabledPortalKeys(enabledKeys);
    } catch (error) {
      console.error("Error fetching connected portals:", error);
      setEnabledPortalKeys(new Set());
    }
  };

  useEffect(() => {
    if (isVendorIntegrationsEnabled) {
      fetchConnectedPortals();
    }
  }, [isVendorIntegrationsEnabled]);

  const allVendorOptions = [
    {
      name: "Dice Search",
      path: "/dice-search",
      onClick: handleDiceSearchNavigation,
    },
    {
      name: "Monster Search ( IND )",
      path: "/monster-search-ind",
      onClick: () => {},
    },
    {
      name: "Monster Search ( USA )",
      path: "/monster-search-usa",
      onClick: handleMonsterUsaSearchNavigation,
    },
    {
      name: "IRMT Search",
      path: "/irmt-search",
      onClick: handleIrmtSearchNavigation,
    },
  ];

  const vendorListOptions = isVendorIntegrationsEnabled
    ? allVendorOptions.filter((option) =>
        enabledPortalKeys.has(VENDOR_PORTAL_KEY_MAP[option.name]),
      )
    : [];

  return (
    <div>
      <div className="header-main-container">
        <div className="header-icon-title-container">
          <img
            alt=""
            className="header-title-icon"
            src={isDarkMode ? clientsPageDarkIcon : clientsPageIcon}
          />
          <h2 className="header-container">Vendors</h2>
        </div>
        <div className="candidate-header-button-container">
          <div className="selection-actions" style={{ gap: "10px" }}>
            <div className="select-button-container">
              <Button
                label="Create"
                event={handleOpenInviteModal}
                iconSrc={addIcon}
                iconWidth="15px"
                className="create-button"
                style={{ padding: "5px 10px" }}
              />
            </div>
            {isVendorIntegrationsEnabled && vendorListOptions.length > 0 && (
              <div className="page-selector-dropdown">
                <PageSelector
                  dropdownHeading="Search Portal"
                  options={vendorListOptions}
                  iconWidth="10px"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="client-page-outer-container">
        {hasVendorProfiles && (
          <div className="vendor-search-container-wrapping">
            <div className="page-selector-container">
              <GlobalSearchBox
                isDarkMode={isDarkMode}
                titleIconDark={VendorSearchDarkIcon}
                titleIconLight={VendorSearchLightIcon}
                titleIconAlt="Vendor Search"
                value={searchQuery}
                onChange={handleInputChange}
                onSearch={handleVendorSearch}
                suggestions={filteroptions}
                placeholder={
                  "Search using vendor name, contact name , or email"
                }
                subText=""
                searchTitle="Vendor Search"
                buttonLabel="Search"
                resetKey={searchResetKey}
                showClearSearch={hasSearched}
                onClear={handleBackToVendorsList}
                filter="true"
                onFilterClick={onFilterClick}
                filterOptions={filteroptions}
                askmeanythingOnKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleVendorSearch();
                  }
                }}
                enableGlobalEnter={true}
              />
            </div>
            {hasSearched && (
              <div className="back-to-vendors-list-button">
                <Button
                  label="Back to Vendors List"
                  event={handleBackToVendorsList}
                  iconSrc={rightArrowIcon}
                  className={`can-btn ${"active"}`}
                  style={{ marginBottom: "-15px" }}
                />
              </div>
            )}
          </div>
        )}
        <div className="client-page-inner-container">
          {isCreatingVendor ||
          !isFetchCompleted ||
          (isInitialLoading && !isLoadingMore) ? (
            <div className="inner-page-outer-container">
              <div className="client-cards-container">
                {Array.from({ length: 30 }).map((_, index) => (
                  <DynamicSkeleton
                    key={index}
                    variant="rectangular"
                    dimensions={{
                      width: "100%",
                      height: "200px",
                      sx: { borderRadius: "16px" },
                    }}
                  />
                ))}
              </div>
            </div>
          ) : vendorList.length > 0 ? (
            <div className="client-cards-container">
              {vendorList.map((client, index) => (
                <div
                  key={index}
                  className="client-card-outer-container"
                  ref={index === vendorList.length - 1 ? lastElement : null}
                >
                  <VendorCard
                    key={client.id}
                    client={client}
                    viewVendor={() => {
                      getVendorsDetails(client.id);
                    }}
                    editVendor={(vendorId) => {
                      getVendorsDetails(vendorId);
                      setTimeout(() => {
                        setIsEditingVendor(true);
                      }, 300);
                    }}
                  />
                </div>
              ))}
              {isLoadingMore && (
                <>
                  {Array.from({ length: 30 }).map((_, idx) => (
                    <DynamicSkeleton
                      key={`scroll-skeleton-${idx}`}
                      variant="rectangular"
                      dimensions={{
                        width: "100%",
                        height: "200px",
                        sx: { borderRadius: "16px" },
                      }}
                    />
                  ))}
                </>
              )}
            </div>
          ) : hasSearched ? (
            <div className="workspace-outer-main-container">
              <div className="vendor-workspace-outer-container">
                <h3>No Search Results Found</h3>
                <AnimationPlayer
                  animationSrc={sendIconDarkAnimation}
                  playerHeight="300px"
                  playerWidth="300px"
                />
              </div>
            </div>
          ) : isInitialLoading || isLoadingMore ? (
            <div className="workspace-outer-main-container-loader">
              <VybogTALLoaderAnimation />
            </div>
          ) : (
            <div className="workspace-outer-main-container">
              <div className="workspace-outer-container">
                <div
                  className="create-text-content"
                  style={{ textAlign: "center", marginTop: "100px" }}
                >
                  <img
                    src={isDarkMode ? createDarkClientIcon : createClientIcon}
                    alt="InterviewIcon"
                    className="interview-icon"
                    style={{ marginBottom: "-40px", marginLeft: "90px" }}
                  />
                  <h3>
                    Create a <span className="inner-span">New Vendor</span>
                  </h3>
                  <div className="client-workspace-button-container">
                    <Button
                      label="Create Vendor"
                      event={handleOpenInviteModal}
                      className="create-button"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <SidePopup
          isOpen={isModalOpen}
          onClose={handleCloseInviteModal}
          title="Create Vendor"
          sidePopupWidth={"var(--vend-side-popup-w)"}
        >
          <div className="client-popup-container">
            <div className="create-client-details">
              <DynamicTextField
                label="Vendor Name"
                type="text"
                name="nameOfVendor"
                placeholder="e.g. StriveTech Inc."
                value={formik.values.nameOfVendor}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.nameOfVendor && formik.errors.nameOfVendor
                }
                errorMessage={formik.errors.nameOfVendor}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
              <div className="textfield-container">
                <label
                  style={{ marginBottom: "10px", fontWeight: "600" }}
                  required={true}
                >
                  Priority
                  <span className="required-asterisk">*</span>
                </label>
                <SelectInput
                  options={vendorPriority}
                  name="vendorPriority"
                  value={formik.values.vendorPriority}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldTouched("vendorPriority", true);
                  }}
                  onBlur={() => formik.setFieldTouched("vendorPriority", true)}
                  error={
                    formik.touched.vendorPriority &&
                    Boolean(formik.errors.vendorPriority) &&
                    !formik.values.vendorPriority
                  }
                  errorMessage={
                    formik.touched.vendorPriority &&
                    formik.errors.vendorPriority &&
                    !formik.values.vendorPriority
                      ? formik.errors.vendorPriority
                      : ""
                  }
                  labelStyle={{ marginBottom: "10px" }}
                  className="textfield-label"
                />
              </div>
              <div className="textfield-container">
                <label
                  style={{ marginBottom: "10px", fontWeight: "600" }}
                  required={true}
                >
                  Vendor Status
                  <span className="required-asterisk">*</span>
                </label>
                <SelectInput
                  options={vendorStatus}
                  name="vendorStatus"
                  value={formik.values.vendorStatus}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldTouched("vendorStatus", true);
                  }}
                  onBlur={() => formik.setFieldTouched("vendorStatus", true)}
                  error={
                    formik.touched.vendorStatus &&
                    Boolean(formik.errors.vendorStatus) &&
                    !formik.values.vendorStatus
                  }
                  errorMessage={
                    formik.touched.vendorStatus &&
                    formik.errors.vendorStatus &&
                    !formik.values.vendorStatus
                      ? formik.errors.vendorStatus
                      : ""
                  }
                  labelStyle={{ marginBottom: "10px" }}
                  className="textfield-label"
                />
              </div>
              <DynamicTextField
                label="Contact Person Name"
                type="text"
                name="contactPersonName"
                placeholder="e.g. Alicia Carter."
                value={formik.values.contactPersonName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.contactPersonName &&
                  formik.errors.contactPersonName
                }
                errorMessage={formik.errors.contactPersonName}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
              <DynamicTextField
                label="Contact Designation"
                type="text"
                name="contactDesignation"
                placeholder="e.g. Alicia Carter."
                value={formik.values.contactDesignation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.contactDesignation &&
                  formik.errors.contactDesignation
                }
                errorMessage={formik.errors.contactDesignation}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
              />
              <div className="create-clients-contact-details">
                <DynamicTextField
                  label="Email"
                  type="email"
                  name="email"
                  placeholder="e.g. marcus.nguyen@strivetech.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && formik.errors.email}
                  errorMessage={formik.errors.email}
                  required={true}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <PhoneNumberInput
                  value={formik.values.mobile}
                  onChange={handlePhoneInputChange}
                  onBlur={() => formik.setFieldTouched("mobile", true)}
                  error={formik.errors.mobile}
                  touched={formik.touched.mobile}
                  placeholder="e.g. (415) 555-0198"
                  label="Contact No."
                  width="100%"
                  height="40px"
                  countryListWidth="300px"
                  phoneContainerStyle={{ marginBottom: "15px" }}
                  required={true}
                />
              </div>
            </div>

            <h3 style={{ width: "fit-content" }}>Bank Details</h3>
            <div className="vendor-clienţ-bank-details">
              <DynamicTextField
                label="Federal Tax"
                name="federalTax"
                placeholder="Enter your Federal Tax"
                value={formik.values.federalTax}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.federalTax && formik.errors.federalTax}
                errorMessage={formik.errors.federalTax}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="Bank Name"
                name="bankName"
                placeholder="Name of the bank"
                value={formik.values.bankName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.bankName && formik.errors.bankName}
                errorMessage={formik.errors.bankName}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="Account Name"
                name="accountName"
                placeholder="Enter Your Account Name"
                value={formik.values.accountName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.accountName && formik.errors.accountName}
                errorMessage={formik.errors.accountName}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="Account Number"
                name="accountNumber"
                placeholder="Enter Your Account Number"
                value={formik.values.accountNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.accountNumber && formik.errors.accountNumber
                }
                errorMessage={formik.errors.accountNumber}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="Routing Number"
                name="routingNumber"
                placeholder="Enter Your Routing Number"
                value={formik.values.routingNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.routingNumber && formik.errors.routingNumber
                }
                errorMessage={formik.errors.routingNumber}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="Nature of Account"
                name="natureOfAccount"
                placeholder="Checking / Savings"
                value={formik.values.natureOfAccount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.natureOfAccount &&
                  formik.errors.natureOfAccount
                }
                errorMessage={formik.errors.natureOfAccount}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="FARCA reporting code"
                name="farcaCode"
                placeholder="Enter FARCA reporting code (if any)"
                value={formik.values.farcaCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.farcaCode && formik.errors.farcaCode}
                errorMessage={formik.errors.farcaCode}
                style={{ width: "100%" }}
              />

              <DynamicTextField
                label="Exempt payee code"
                name="exemptPayeeCode"
                placeholder="Enter exempt payee code (if any)"
                value={formik.values.exemptPayeeCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.exemptPayeeCode &&
                  formik.errors.exemptPayeeCode
                }
                errorMessage={formik.errors.exemptPayeeCode}
                style={{ width: "100%" }}
              />
            </div>

            <div className="create-client-location-details">
              <h3>Vendor Location Details</h3>
              <div className="create-address-container">
                <DynamicTextField
                  label="Address"
                  name="address"
                  placeholder="Enter Your Address"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.address && formik.errors.address}
                  errorMessage={formik.errors.address}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
              </div>

              <div className="create-client-location-container">
                <DynamicTextField
                  label="Country"
                  name="country"
                  placeholder="Country"
                  value={formik.values.country}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.country && formik.errors.country}
                  errorMessage={formik.errors.country}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="State"
                  name="state"
                  placeholder="State"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.state && formik.errors.state}
                  errorMessage={formik.errors.state}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="City"
                  name="city"
                  placeholder="City"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.city && formik.errors.city}
                  errorMessage={formik.errors.city}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="Zipcode"
                  name="zipCode"
                  placeholder="Zipcode"
                  value={formik.values.zipCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.zipCode && formik.errors.zipCode}
                  errorMessage={formik.errors.zipCode}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
              </div>
            </div>
            <div className="vendor-client-file-input">
              <div style={{ width: "100%" }}>
                <label>ACH Upload</label>
                <input
                  ref={achFileRef}
                  type="file"
                  name="achFile"
                  accept=".pdf,.doc,.docx"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "achFile",
                      event.currentTarget.files[0],
                    );
                  }}
                  style={{ display: "block", marginTop: "5px" }}
                />
                {formik.touched.achFile && formik.errors.achFile && (
                  <div className="error">{formik.errors.achFile}</div>
                )}
              </div>
              <div style={{ width: "100%" }}>
                <label>VOID Cheque Upload</label>
                <input
                  ref={voidChequeRef}
                  type="file"
                  name="voidChequeFile"
                  accept=".pdf,.doc,.docx"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "voidChequeFile",
                      event.currentTarget.files[0],
                    );
                  }}
                  style={{ display: "block", marginTop: "5px" }}
                />
                {formik.touched.voidChequeFile &&
                  formik.errors.voidChequeFile && (
                    <div className="error">{formik.errors.voidChequeFile}</div>
                  )}
              </div>
            </div>

            <div className="vendor-client-file-input ">
              <div style={{ width: "100%" }}>
                <label>Audit Document</label>
                <input
                  ref={auditDocRef}
                  type="file"
                  name="DocumentType"
                  accept=".pdf,.doc,.docx"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "documentType",
                      event.currentTarget.files[0],
                    );
                  }}
                  onBlur={formik.handleBlur}
                  style={{ display: "block", marginTop: "5px" }}
                />
                {formik.touched.documentType && formik.errors.documentType && (
                  <div className="error">{formik.errors.documentType}</div>
                )}
              </div>
            </div>
            <div className="create-client-location-details">
              <div className="skill-header" style={{ marginBottom: "9px" }}>
                <div className="skill-title">
                  {" "}
                  <h3
                    className="desc-inner-header textfield-label"
                    style={{ margin: 0 }}
                  >
                    Remarks
                  </h3>
                </div>
              </div>
              <div>
                <TextArea
                  placeholder={"Enter Remarks"}
                  name="remarks"
                  value={formik.values.remarks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.remarks && formik.errors.remarks}
                  errorMessage={formik.errors.remarks}
                />
              </div>
            </div>
            <div className="client-creation-button-container">
              <Button
                label="Cancel"
                event={handleCloseInviteModal}
                backgroundColor="#6860ee"
                isCancel={true}
              />
              <Button
                label="Create Vendor"
                event={handleCreateVendor}
                backgroundColor="#6860ee"
                className="create-button"
              />
            </div>
          </div>
        </SidePopup>
        <SidePopup
          isOpen={viewVendor}
          onClose={() => {
            handleCloseClientDetails();
          }}
          title={selectedVendor?.name}
          sidePopupStyle={{
            width: "80%",
          }}
          headerRightContent={
            <div style={{ display: "flex", alignItems: "center" }}>
              {isEditingVendor ? (
                <>
                  <Button
                    label="Save"
                    event={saveVendorChanges}
                    style={{ marginRight: "10px", padding: "8px 15px" }}
                    backgroundColor="#6860EE"
                    color="#FFFFFF"
                    border="none"
                  />
                  <Button
                    label="Cancel"
                    event={handleCancelEditClient}
                    style={{ padding: "8px 15px" }}
                    backgroundColor="#fff"
                    color="#000"
                    border="1px solid #ddd"
                  />
                </>
              ) : (
                <>
                  <CustomTooltip title="Edit Vendor" arrow>
                    <img
                      src={editIcon}
                      alt="Edit"
                      onClick={handleEditClient}
                      style={{
                        cursor: "pointer",
                        width: "22px",
                        padding: "8px 15px",
                      }}
                    />
                  </CustomTooltip>
                  {selectedVendor?.id && !isCepheaVendor(selectedVendor.id) && (
                    <CustomTooltip title="Delete Vendor" arrow>
                      <img
                        src={deleteIcon}
                        alt="Delete"
                        onClick={handleOpenClientDeleteDialog}
                        style={{
                          cursor: "pointer",
                          width: "22px",
                          padding: "8px",
                        }}
                      />
                    </CustomTooltip>
                  )}
                </>
              )}
            </div>
          }
        >
          {selectedVendor && (
            <div className="client-main-container">
              {isEditingVendor && (
                <div className="client-name-edit">
                  <TextInput
                    label="Vendor Name"
                    name="nameOfVendor"
                    placeholder="Vendor Name"
                    required={true}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.nameOfVendor && formik.errors.nameOfVendor
                    }
                    errorMessage={formik.errors.nameOfVendor}
                    value={formik.values.nameOfVendor}
                    onChange={formik.handleChange}
                  />
                </div>
              )}

              <div
                style={{
                  padding: "0px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div
                  className={`vendor-candidate-info-outer-container ${
                    isEditingVendor ? "edit-mode" : ""
                  }`}
                >
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={accountIcon}
                        alt="company-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Contact Person{" "}
                        {isEditingVendor && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>

                    <div className="detail-content">
                      {isEditingVendor ? (
                        <TextInput
                          placeholder="Contact Person"
                          name="contactPersonName"
                          value={formik.values.contactPersonName}
                          required={true}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.contactPersonName &&
                            formik.errors.contactPersonName
                          }
                          errorMessage={formik.errors.contactPersonName}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <span className="candidate-email">
                          {selectedVendor?.contact_person || "N/A"}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={jobIcon}
                        alt="job-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Contact Designation{" "}
                      </h4>
                    </div>

                    <div className="detail-content">
                      {isEditingVendor ? (
                        <TextInput
                          name="contactDesignation"
                          placeholder="Designation"
                          value={formik.values.contactDesignation}
                          required={true}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.contactDesignation &&
                            formik.errors.contactDesignation
                          }
                          errorMessage={formik.errors.contactDesignation}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <span className="candidate-email">
                          {selectedVendor?.contact_designation || "N/A"}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={mailIcon}
                        alt="mail-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Email{" "}
                        {isEditingVendor && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>
                    <div className="detail-content">
                      {isEditingVendor ? (
                        <TextInput
                          placeholder="Email"
                          name="email"
                          type="email"
                          value={formik.values.email}
                          required={true}
                          onBlur={formik.handleBlur}
                          error={formik.touched.email && formik.errors.email}
                          errorMessage={formik.errors.email}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <h5 className="client-details-value">
                          {selectedVendor?.email || "N/A"}
                        </h5>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={phoneIcon}
                        alt="phone-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Phone{" "}
                        {isEditingVendor && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>
                    <div className="detail-content">
                      {isEditingVendor ? (
                        <PhoneNumberInput
                          value={formik.values.mobile}
                          onChange={handlePhoneInputChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.mobile}
                          touched={formik.touched.mobile}
                          placeholder="e.g. (415) 555-0198"
                          width="100%"
                          height="40px"
                          countryListWidth="300px"
                          phoneContainerStyle={{ marginBottom: "15px" }}
                          required={true}
                        />
                      ) : (
                        <h5 className="client-details-value">
                          {selectedVendor?.phone || "N/A"}
                        </h5>
                      )}
                    </div>
                  </div>
                </div>
                <div className="client-tabs-container">
                  <div
                    className={`tab ${
                      activeTab === "Info" ? "job-tab-active" : ""
                    }`}
                    onClick={() => handleTabClick("Info")}
                  >
                    Info
                  </div>
                  <div
                    className={`tab ${
                      activeTab === "History" ? "job-tab-active" : ""
                    }`}
                    onClick={() => handleTabClick("History")}
                  >
                    History
                  </div>
                  <div
                    className={`tab ${
                      activeTab === "Documents" ? "job-tab-active" : ""
                    }`}
                    onClick={() => handleTabClick("Documents")}
                  >
                    Documents
                  </div>
                  <div
                    className={`tab ${
                      activeTab === "Vendor's Candidate" ? "job-tab-active" : ""
                    }`}
                    onClick={() => handleTabClick("Vendor's Candidate")}
                  >
                    Vendor's Candidate
                  </div>
                  <div
                    className={`tab ${
                      activeTab === "Additional Contacts"
                        ? "job-tab-active"
                        : ""
                    }`}
                    onClick={() => handleTabClick("Additional Contacts")}
                  >
                    Additional Contacts
                  </div>
                </div>
              </div>
              <div className="client-details-content-container">
                {renderContent()}
              </div>
            </div>
          )}
          <ContentDialog
            isOpen={showVendorContactPopup}
            onClose={handleCloseContactPopup}
            onCloseIconClose={handleCloseContactPopup}
            submitButtonLabel="Add"
            cancelButtonLabel="Cancel"
            event={contactFormik.handleSubmit}
            contentWidth="50vw"
            contentHeight={"auto"}
            title={"Add Vendor Contact"}
          >
            <div className="add-contact-container" style={{ padding: "25px" }}>
              <DynamicTextField
                label="Contact Person Name"
                type="text"
                name="contactName"
                placeholder="e.g. Alicia Carter."
                value={contactFormik.values.contactName}
                onChange={contactFormik.handleChange}
                onBlur={contactFormik.handleBlur}
                error={
                  contactFormik.touched.contactName &&
                  contactFormik.errors.contactName
                }
                errorMessage={contactFormik.errors.contactName}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
              <DynamicTextField
                label="Contact Person Email"
                type="email"
                name="contactEmail"
                placeholder="e.g. marcus.nguyen@strivetech.com"
                value={contactFormik.values.contactEmail}
                onChange={contactFormik.handleChange}
                onBlur={contactFormik.handleBlur}
                error={
                  contactFormik.touched.contactEmail &&
                  contactFormik.errors.contactEmail
                }
                errorMessage={contactFormik.errors.contactEmail}
                required={true}
                labelStyle={{ marginBottom: "10px" }}
              />
              <PhoneNumberInput
                value={contactFormik.values.contactPhoneNumber}
                onChange={handleContactPhoneInputChange}
                onBlur={() =>
                  contactFormik.setFieldTouched("contactPhoneNumber", true)
                }
                error={contactFormik.errors.contactPhoneNumber}
                touched={contactFormik.touched.contactPhoneNumber}
                placeholder="e.g. (415) 555-0198"
                label="Contact Person Contact No."
                width="100%"
                height="40px"
                countryListWidth="300px"
                phoneContainerStyle={{ marginBottom: "15px" }}
                required={true}
              />
              <DynamicTextField
                label="Contact Designation"
                type="text"
                name="contactDesignation"
                placeholder="e.g. Senior Recruiter"
                value={contactFormik.values.contactDesignation}
                onChange={contactFormik.handleChange}
                onBlur={contactFormik.handleBlur}
                error={
                  contactFormik.touched.contactDesignation &&
                  contactFormik.errors.contactDesignation
                }
                errorMessage={contactFormik.errors.contactDesignation}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
                // required={true}
              />
            </div>
          </ContentDialog>

          <ContentDialog
            isOpen={showEditContactPopup}
            onClose={handleCloseContactPopup}
            onCloseIconClose={handleCloseContactPopup}
            submitButtonLabel="Update"
            cancelButtonLabel="Cancel"
            event={contactFormik.handleSubmit}
            contentWidth="50vw"
            contentHeight={"auto"}
            title={"Edit Vendor Contact"}
          >
            <div className="add-contact-container" style={{ padding: "25px" }}>
              <DynamicTextField
                label="Contact Person Name"
                type="text"
                name="contactName"
                placeholder="e.g. Alicia Carter."
                value={contactFormik.values.contactName}
                onChange={contactFormik.handleChange}
                onBlur={contactFormik.handleBlur}
                error={
                  contactFormik.touched.contactName &&
                  contactFormik.errors.contactName
                }
                errorMessage={contactFormik.errors.contactName}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
              <DynamicTextField
                label="Contact Person Email"
                type="email"
                name="contactEmail"
                placeholder="e.g. marcus.nguyen@strivetech.com"
                value={contactFormik.values.contactEmail}
                onChange={contactFormik.handleChange}
                onBlur={contactFormik.handleBlur}
                error={
                  contactFormik.touched.contactEmail &&
                  contactFormik.errors.contactEmail
                }
                errorMessage={contactFormik.errors.contactEmail}
                required={true}
                labelStyle={{ marginBottom: "10px" }}
              />
              <PhoneNumberInput
                value={contactFormik.values.contactPhoneNumber}
                onChange={handleContactPhoneInputChange}
                onBlur={() =>
                  contactFormik.setFieldTouched("contactPhoneNumber", true)
                }
                error={contactFormik.errors.contactPhoneNumber}
                touched={contactFormik.touched.contactPhoneNumber}
                placeholder="e.g. (415) 555-0198"
                label="Contact Person Contact No."
                width="100%"
                height="40px"
                countryListWidth="300px"
                phoneContainerStyle={{ marginBottom: "15px" }}
                required={true}
              />
              <DynamicTextField
                label="Contact Designation"
                type="text"
                name="contactDesignation"
                placeholder="e.g. Senior Recruiter"
                value={contactFormik.values.contactDesignation}
                onChange={contactFormik.handleChange}
                onBlur={contactFormik.handleBlur}
                error={
                  contactFormik.touched.contactDesignation &&
                  contactFormik.errors.contactDesignation
                }
                errorMessage={contactFormik.errors.contactDesignation}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
              />
            </div>
          </ContentDialog>

          <ContentDialog
            isOpen={showDeleteContactPopup}
            onClose={() => {
              setShowDeleteContactPopup(false);
              setSelectedContact(null);
            }}
            onCloseIconClose={() => {
              setShowDeleteContactPopup(false);
              setSelectedContact(null);
            }}
            submitButtonLabel="Delete"
            cancelButtonLabel="Cancel"
            event={handleDeleteVendorContactDetails}
            contentWidth="40vw"
            contentHeight={"auto"}
            title={"Delete Contact"}
          >
            <div style={{ padding: "25px", textAlign: "center" }}>
              <p>Are you sure you want to delete this contact?</p>
              <p>
                <strong>{selectedContact?.name}</strong> -{" "}
                {selectedContact?.email}
              </p>
              <p style={{ color: "#666", fontSize: "14px", marginTop: "10px" }}>
                This action cannot be undone.
              </p>
            </div>
          </ContentDialog>
        </SidePopup>
        <ConfirmationPopup
          isOpen={isVendorDeleteDialogOpen}
          onClose={() => setIsVendorDeleteDialogOpen(false)}
          onConfirm={handleDeleteVendors}
          title="Delete Vendor?"
          subTitle="Confirmation required"
          message={
            <span>
              This will delete{" "}
              <span
                style={{
                  color: "#6665ea",
                  fontWeight: "bold",
                }}
              >
                "{applyEllipsis(selectedVendor?.name, 35)}"
              </span>
              , Are you sure you want to delete this Vendor? This action cannot
              be undone.
            </span>
          }
          cancelLabel="No, Cancel"
          confirmLabel="Yes, Delete"
          confirmButtonClass="popup-button-danger"
        />
      </div>
      {isCandidateModalOpen && selectedCandidateForModal && (
        <SidePopup
          isOpen={isCandidateModalOpen}
          onClose={closeCandidateModal}
          title="Candidate Details"
          width="80%"
        >
          <CandidateDetailsContainer
            candidate={selectedCandidateForModal}
            activeTab={candidateActiveTab}
            setActiveTab={setCandidateActiveTab}
            handleTabChange={handleCandidateTabChange}
            hasSearched={false}
            hasRecommendedCandidates={false}
            isEditingCandidate={isEditingCandidate}
            setIsEditingCandidate={setIsEditingCandidate}
            handleEditCandidate={handleEditCandidate}
            saveCandidateChanges={saveCandidateChanges}
            resetCandidateEdit={resetCandidateEdit}
            handleCandidateChange={handleCandidateChange}
            editedCandidateData={editedCandidateData}
            emailError={candidateEmailError}
            setEmailError={setCandidateEmailError}
            emailTouched={candidateEmailTouched}
            setEmailTouched={setCandidateEmailTouched}
            hideSearchBox={true}
            vendorList={vendorList}
            vendorOptionLoading={vendorOptionLoading}
            handleVendorInputChange={handleVendorInputChange}
            assignedVendor={assignedVendor}
          />
        </SidePopup>
      )}
    </div>
  );
}

export default Vendors;
